import { Typography } from "@mui/material";

export const PageHeaderTitle = ({ title }: { title: string }) => {
  return (
    <Typography fontSize={"30px"} lineHeight={"38px"} fontWeight={"600"}>
      {title}
    </Typography>
  );
};
